var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(-789.001 -207)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 20,
    height: 20,
    transform: "translate(789.001 207)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    transform: "translate(1.141 1.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(790.981 208.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M742.355,9292.415v-3.389a1.488,1.488,0,0,0-.449-2.906,1.478,1.478,0,0,0-1,.39l-2.939-1.694a1.486,1.486,0,1,0-2.937-.322,1.545,1.545,0,0,0,.033.322l-2.939,1.694a1.485,1.485,0,0,0-2.488,1.1,1.5,1.5,0,0,0,1.038,1.418v3.389a1.488,1.488,0,0,0,.449,2.906,1.479,1.479,0,0,0,1-.39l2.939,1.694a1.543,1.543,0,0,0-.033.321,1.486,1.486,0,1,0,2.937-.321l2.939-1.694a1.485,1.485,0,0,0,2.488-1.1A1.494,1.494,0,0,0,742.355,9292.415Zm-.9,0a1.482,1.482,0,0,0-1,1.738l-2.939,1.7a1.48,1.48,0,0,0-2,0l-2.94-1.7a1.482,1.482,0,0,0-1-1.738v-3.393a1.482,1.482,0,0,0,1-1.738l2.94-1.7a1.48,1.48,0,0,0,2,0l2.939,1.7a1.482,1.482,0,0,0,1,1.738Z",
    transform: "translate(-729.635 -9283.007)",
    fill: "#3b81f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    transform: "translate(3.949 4.784)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 1.217,
    height: 5.86,
    transform: "translate(2.321)",
    fill: "#3b81f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 1.217,
    height: 5.86,
    transform: "translate(5.86 2.322) rotate(90)",
    fill: "#3b81f6"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScale);
export default __webpack_public_path__ + "static/media/icon-scale.5ae084bace8c3b7a7414a0c95d866460.svg";
export { ForwardRef as ReactComponent };